var _templateObject, _templateObject2;
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import scStyled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import DescriptionIcon from '@mui/icons-material/Description';
var borderRadius = function borderRadius(edges, theme) {
  switch (edges) {
    case 'rounded':
      return 99;
    case 'sharp':
      return 0;
    default:
      return theme.shape.borderRadius;
  }
};
export var StyledFileIcon = styled(DescriptionIcon)(function (_ref) {
  var compact = _ref.compact,
    theme = _ref.theme;
  return {
    color: theme.palette.default.light,
    margin: compact ? "0 " + theme.spacing(2) + " 0 0" : '0 auto',
    fontSize: compact ? '2rem' : '4rem'
  };
});
export var StyledSavedImage = styled(motion.div)(function (_ref2) {
  var edges = _ref2.edges,
    theme = _ref2.theme;
  return {
    borderRadius: borderRadius(edges, theme),
    border: "1px solid " + theme.palette.text.secondary,
    padding: theme.spacing(6, 4),
    '& img': {
      maxWidth: '100%',
      width: 'auto',
      hieght: 'auto',
      margin: '0 auto',
      boxShadow: theme.shadows[10],
      display: 'block'
    }
  };
});
export var StyledEditor = styled('div')(function (_ref3) {
  var edges = _ref3.edges,
    showError = _ref3.showError,
    theme = _ref3.theme;
  return {
    width: '100%',
    padding: theme.spacing(6, 4),
    backgroundImage: "linear-gradient(45deg, " + theme.palette.grey[700] + " 25%, transparent 25%), linear-gradient(-45deg, " + theme.palette.grey[700] + " 25%, transparent 25%), linear-gradient(45deg, transparent 75%, " + theme.palette.grey[700] + " 75%), linear-gradient(-45deg, transparent 75%, " + theme.palette.grey[700] + " 75%)",
    backgroundSize: '20px 20px',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
    border: "1px solid " + (showError ? theme.palette.error.main : theme.palette.primary.main),
    borderRadius: borderRadius(edges, theme),
    '& .ReactCrop': {
      margin: '0 auto',
      display: 'block'
    }
  };
});
export var StyledCircularProgress = styled(CircularProgress)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  marginTop: -20,
  marginLeft: -20,
  zIndex: 1
});
export var StyledDeleteIcon = scStyled.span(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 50%;\n    right: 25px;\n    z-index: 9;\n    background: transparent;\n    color: ", ";\n    width: 48px;\n    height: 48px;\n    font-size: 20px;\n    transition: all 0.25s ease-in-out;\n    transform: translateY(-50%) scale(0.9);\n    box-shadow: ", ";\n    border-radius: 50%;\n    &:hover {\n      background: rgba(0, 0, 0, 0.04);\n      transform: translateY(-50%) scale(1.05);\n      color: ", ";\n      box-shadow: ", ";\n    }\n  "])), theme.palette.grey.main, theme.shadows[2], theme.palette.secondary.main, theme.shadows[4]);
});